// iter216 · Owner-as-customer ribbon.
//
// When an owner taps the "User" side of the DASHBOARD toggle on their
// own profile page, we set `sessionStorage.habano.owner_as_customer` to
// the dashboard path they came from ("/vendor" | "/business"). On
// Ride Mode (`/`) this ribbon reads that flag and renders a small
// gold-outlined bar with a one-tap "Back to my dashboard" link. Clears
// on tap or on any full-page reload.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useDashboardI18n } from "../lib/useDashboardI18n";

const KEY = "habano.owner_as_customer";

export function markOwnerAsCustomer(dashboardPath) {
  try { sessionStorage.setItem(KEY, dashboardPath); } catch { /* ignore */ }
}

export default function OwnerAsCustomerRibbon() {
  const { t, lang } = useDashboardI18n("vendor");
  const [target, setTarget] = useState(null);
  useEffect(() => {
    try { setTarget(sessionStorage.getItem(KEY)); } catch { /* ignore */ }
  }, []);
  if (!target) return null;

  const clear = () => {
    try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
    setTarget(null);
  };

  const msg = lang === "es"
    ? "Estás viendo tu perfil como cliente"
    : "You are viewing your profile as a customer";
  const back = lang === "es" ? "Volver a mi tablero" : "Back to my dashboard";

  return (
    <div
      data-testid="owner-as-customer-ribbon"
      className="w-full px-4 py-2 flex items-center justify-between gap-2"
      style={{
        background: "rgba(232,184,75,0.10)",
        borderBottom: "1px solid rgba(232,184,75,0.35)",
        color: "#F5F1E8",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 13,
      }}
    >
      <span className="truncate">{msg}</span>
      <Link
        to={target}
        onClick={clear}
        data-testid="owner-back-to-dashboard"
        className="inline-flex items-center gap-1 shrink-0"
        style={{
          minHeight: 40, padding: "6px 14px", borderRadius: 999,
          background: "transparent", color: "#E8B84B",
          border: "1px solid #E8B84B", fontSize: 13, fontWeight: 600,
        }}
      >
        <ChevronLeft className="w-4 h-4" strokeWidth={1.5}/> {back}
      </Link>
    </div>
  );
}
